const getDefaultState = () => {
	return {
		project: [],
		project_form: {
			title: null,
			address: null,
			image: null,
			is_published: null,
		}
	}
}

const default_state = getDefaultState()

export { default_state }